import {useEffect, useState} from "react";

export default function useReplaceSearchParams() {
    const [searchParams, setSearchParams] = useState((new URL(document.location)).searchParams);
    const handleSearchParams = (params) => {
        if (typeof (params) !== "object") {
            setSearchParams(new URLSearchParams());
            return;
        }
        if (searchParams.toString() !== params.toString()) setSearchParams(params);
    }
    useEffect(() => {
        let searchParamString = searchParams.toString();
        let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname
        if (searchParamString) newUrl += '?' + searchParamString;
        window.history.replaceState({path: newUrl}, '', newUrl);
    }, [searchParams])
    return [searchParams, handleSearchParams]
}